import _ from 'lodash';
import queryString from 'query-string';
import { getRegistrationParams } from '../../services/auth';

export const getCallbackParams = () => {
  const queryParams = queryString.parse(window.location.search);
  const registrationParams = getRegistrationParams();

  return {
    callbackUri: queryParams.callbackUri || registrationParams.callbackUri || false,
    clientId: queryParams.clientId || registrationParams.clientId || false,
  };
};

export const buildCallbackQueryString = ({ callbackUri, clientId }) => {
  if (!callbackUri) {
    return '';
  }

  return clientId
    ? `?callbackUri=${callbackUri}&clientId=${clientId}`
    : `?callbackUri=${callbackUri}`;
};

export const isUserVerified = (userDataParsed) => userDataParsed['custom:verified'] === 'Y';

export const isAddressComplete = (userDataParsed) => {
  const addressIso = _.get(userDataParsed, 'address_iso', '');

  if (addressIso) {
    const [streetNumber, street, city, state, zip] = addressIso.split('|');
    return Boolean(
      ((streetNumber && street) || userDataParsed.premise)
      && city && state && zip,
    );
  }

  return Boolean(
    ((userDataParsed.streetNumber && userDataParsed.street) || userDataParsed.premise)
    && userDataParsed.city && userDataParsed.state && userDataParsed.zip,
  );
};

export const resolvePostEmailVerificationRoute = (userDataParsed, { callbackUri, clientId }) => {
  const callbackQueryString = buildCallbackQueryString({
    callbackUri,
    clientId, 
  });

  if (isUserVerified(userDataParsed)) {
    return {
      type: 'push',
      path: `/update-profile${callbackQueryString}`, 
    };
  }

  const destination = isAddressComplete(userDataParsed)
    ? '/idv/migrate'
    : '/complete-registration';

  return {
    type: 'push',
    path: `${destination}${callbackQueryString}`, 
  };
};

export const shouldSaveRegistrationParams = (path) => path.startsWith('/complete-registration');
